import styled from "@emotion/styled";
import { Button, Typography } from "@mui/material";
import ModalInfoMore from "components/Modal/ModalInfoMore";
import { useState } from "react";
import { ProductProps } from "services/products";
import { breakpoints } from "styles/utils";

const WrapperPlatformContent = styled.div`
  @media (min-width: ${breakpoints.large}) {
    margin-top: 100px;
  }
`;

const DesktopInnerCard = styled.div`
  @media (min-width: ${breakpoints.large}) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 100px;
  }
`;

const ProductDescription = styled(Typography)`
  color: #000;
  margin-bottom: 20px;
  font-weight: 500;
`;

const ProductKey = styled(ProductDescription)`
  border: 1px solid #000000;
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.17);
  border-radius: 12px;
  padding: 30px 8px;
  background: #ffffff;

  @media (min-width: ${breakpoints.large}) {
    padding: 24px 12px;
  }
`;

const GridProduct = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 20px;
`;

const ProductTitle = styled(Typography)`
  color: #000;
  font-weight: 500;
  margin-bottom: 50px;
`;

const Link = styled.a`
  color: #15997b;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
    text-decoration: none;
  }
`;

export type ProductActivatedCardProps = {} & ProductProps;

const ProductActivatedCard = ({
  productImage,
  productName,
  productKey,
  productActivatedDate,
  description,
}: ProductActivatedCardProps) => {
  const [openMoreInfoModal, setOpenMoreInfoModal] = useState(false);

  const handleOpenMoreInfoModal = () => {
    setOpenMoreInfoModal(true);
  };

  const handleCloseMoreInfoModal = () => {
    setOpenMoreInfoModal(false);
  };

  return (
    <>
      <DesktopInnerCard>
        <GridProduct>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              alignItems: "center",
              marginBottom: "50px",
            }}
          >
            <img
              height={91}
              width={82}
              loading="lazy"
              alt="logo kaspersky"
              src={productImage}
            />
            <Button
              variant="contained"
              style={{
                backgroundColor: "#15997B",
              }}
              onClick={handleOpenMoreInfoModal}
            >
              Saiba mais
            </Button>
          </div>

          <div>
            <ProductTitle variant="h1">{productName}</ProductTitle>
            <ProductDescription variant="h2">
              <b>Data da aquisição:</b>{" "}
              {productActivatedDate &&
                new Date(productActivatedDate).toLocaleDateString("pt-BR")}
            </ProductDescription>
            <ProductDescription variant="h2">
              Se você tiver dúvidas, nosso serviço ao cliente está à sua
              disposição.
            </ProductDescription>
          </div>
        </GridProduct>

        <div>
          <ProductDescription variant="h2">
            Para ativar o produto, você precisa do seu código de acesso pessoal
            abaixo:
          </ProductDescription>
          <ProductKey variant="h2" align="center">
            {productKey}
          </ProductKey>
        </div>
      </DesktopInnerCard>

      <WrapperPlatformContent>
        <ProductDescription variant="h2" align="center">
          Para ativar sua licença, acesse a página{" "}
          <Link
            target="_blank"
            rel="noreferrer"
            href="https://my.kaspersky.com"
          >
            https://my.kaspersky.com
          </Link>{" "}
          e siga as instruções acima.
        </ProductDescription>
      </WrapperPlatformContent>
      <ModalInfoMore
        open={openMoreInfoModal}
        onClose={handleCloseMoreInfoModal}
        productImage={productImage}
        productName={productName}
        description={description}
      />
    </>
  );
};
export default ProductActivatedCard;
